<div class="container" *ngIf="ready">
	<div class="tagline-tablet">
		<div class="tagline">{{ tagLine | translate }}</div>
	</div>

	<!-- Login user: username + password / SSO -->
	<div class="form-container">
		<div class="title">{{ "SIGN_IN" | translate }}</div>

		<form name="loginForm" (ngSubmit)="login()">
			<mat-form-field appearance="fill" class="full-width">
				<span matPrefix><i class="far fa-user"></i></span>
				<mat-label>{{'EMAIL' | translate}}</mat-label>
				<input type="text" [(ngModel)]="username" matInput name="username" auto-fillable-field
					autocapitalize="off" autofocus="autofocus" data-cy="login-email">
			</mat-form-field>

			<mat-form-field appearance="fill" class="full-width">
				<span matPrefix><i class="far fa-lock"></i></span>
				<mat-label>{{'PASSWORD' | translate}}</mat-label>
				<input type="password" [(ngModel)]="password" matInput name="password" auto-fillable-field
					data-cy="login-password">
			</mat-form-field>

			<p class="error-message" *ngIf="passwordErrorOccured" data-cy="invalid-user-password">
				{{'INVALID_USERNAME_OR_PASSWORD' | translate }}
			</p>
			<p class="error-message" *ngIf="capslockOn" data-cy="capslock-on">
				{{ 'WARNING_CAPSLOCK_IS_ON' | translate }}
			</p>

			<div class="actions-container">
				<a [routerLink]="['/login/forgot-password']" (click)="passwordErrorOccured=false"
					class="rb-a forgot-pw">
					{{ 'FORGOT_PASSWORD' | translate }}
				</a>
				<!-- Submit button instead of bb-button, we need type="submit" to trigger Hubspot user recognition (form POST request) -->
				<button type="submit" class="native-button-submit" [class.disabled]="busy" data-cy="login-button">
					<bb-button theme="rb" backgroundColor="blue" size="big" [disabled]="busy">{{ 'SIGN_IN' | translate
						}}</bb-button>
				</button>
			</div>
		</form>

		<login-user-sso *ngIf="ssoProviders" [ssoProviders]="ssoProviders"></login-user-sso>

		<div class="encrypted">
			<i class="far fa-lock"></i>
			<span>{{ "CONNECTION_IS_ENCRYPTED" | translate }}</span>
		</div>
	</div>
</div>
